var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sessions"},[_c('ag-table',_vm._g({attrs:{"data-source-api":_vm.getAllSessions,"grid-options":_vm.gridOptions,"permissions":_vm.permissions,"rtl":false,"is-entities-response":false}},_vm.dynamicEvents))],1)}
var staticRenderFns = []

export { render, staticRenderFns }